import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCombinedStore } from "../store";
import api from "../services/api.service";
import * as Styles from "../styles/AllOptons.styles";
import * as AlfredoComponents from "./";
import { set } from "date-fns";

interface AllOptionsModalProps {
  allOptionsOpen: boolean;
  setCurrentModalOpen: React.Dispatch<React.SetStateAction<string>>;
  setConfirmModalOpen: React.Dispatch<
    React.SetStateAction<{
      title: string;
      description: string;
      confirmationAction: () => void;
      cancelationAction: () => void;
    }>
  >;
  setComponent: () => void;
  getPeriodInfo: () => void;
  modalPosition: { top: number; left: number };
}

const AllOptionsModal: React.FC<AllOptionsModalProps> = ({
  allOptionsOpen,
  setCurrentModalOpen,
  setConfirmModalOpen,
  setComponent,
  getPeriodInfo,
  modalPosition,
}) => {
  const { saleOption } = useParams();
  const [searchValueInput, setSearchValueInput] = useState("");
  const navigate = useNavigate();

  const {
    setSubsidiaryDataZustand,
    subsidiaryDataZustand,
    setOrderDataZustand,
    orderDataZustand,
    authUserZustand,
    setMessageZustand,
    saleOptionEditorOpenZustand,
  } = useCombinedStore((state) => {
    return {
      setSubsidiaryDataZustand: state.setSubsidiaryDataZustand,
      subsidiaryDataZustand: state.subsidiaryDataZustand,
      setOrderDataZustand: state.setOrderDataZustand,
      orderDataZustand: state.orderDataZustand,
      setMessageZustand: state.setMessageZustand,
      authUserZustand: state.authUserZustand,
      saleOptionEditorOpenZustand: state.saleOptionEditorOpenZustand,
    };
  });

  const [customerInfoByOrder, setCustomerInfoByOrder] = useState({
    customerName: "",
    customerAddress: "",
    customerAddressComplement: "",
    customerPhone: "",
  });


  const selectedSaleOption =
    subsidiaryDataZustand.selectedPdv.saleOptions.filter(
      (item) => item.itemInfoUuid === saleOption
    )[0];

  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        handleClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClose = () => {
    setCurrentModalOpen("");
    //setAllOptionsOpen(false);
  };

  //Executar funcionalidades da opcao de venda
  const handleButtonClick = (Action: string, event?: React.MouseEvent) => {
    getPeriodInfo();
    switch (Action) {
      case "AddProduct":
        if (orderDataZustand.orderUuid === "") {
          setMessageZustand(
            `Você precisa abrir uma conta antes de adicionar um produto.`,
            `error`
          );
          return;
        } else if (orderDataZustand.orderStatus === 2) {
          setMessageZustand(
            `Você precisa desbloquear a conta antes de adicionar um produto.`,
            `error`
          );
          return;
        } else {
          setCurrentModalOpen("AddProductModal");
          setComponent();
        }
        break;
      case "AddObservation":
        const products = orderDataZustand.products ?? [];
        if (orderDataZustand.orderUuid === "") {
          setMessageZustand(
            `Você precisa abrir uma conta antes de adicionar observações de um produto.`,
            `error`
          );
        } else if (
          orderDataZustand.products?.filter(
            (product: any) => product.productSelected
          ).length === 0 &&
          orderDataZustand.products?.filter(
            (product: any) => product.productSemiSelected
          ).length === 0
        ) {
          setMessageZustand(
            `Você precisa selecionar um produto para adicionar uma observação.`,
            `error`
          );
        } else {
          setCurrentModalOpen("AddObservationModal");
          setComponent();
        }
        break;
      case "CancelOrder":
        if (orderDataZustand.orderUuid === "") {
          setMessageZustand(
            `Você precisa abrir uma conta antes de remover um produto.`,
            `error`
          );
        } else if (Number(orderDataZustand.orderStatus) >= 4) {
          setMessageZustand(
            `Você precisa desbloquear a conta antes de remover um produto.`,
            `error`
          );
        } else if (
          orderDataZustand.products?.filter(
            (product: any) => product.productSelected
          ).length === 0 &&
          orderDataZustand.products?.filter(
            (product: any) => product.productSemiSelected
          ).length === 0
        ) {
          setMessageZustand(
            `Você precisa selecionar um produto para remover.`,
            `error`
          );
        } else {
          setCurrentModalOpen("ConfirmationModal");
          setConfirmModalOpen({
            title: `Remover Produto`,
            description: `Deseja remover o(s) produto(s) selecionado(s)?`,
            confirmationAction: () => {
              setCurrentModalOpen("CancelOrderModal");
              setConfirmModalOpen({
                title: "",
                description: "",
                confirmationAction: () => { },
                cancelationAction: () => { },
              });
            },
            cancelationAction: () => { },
          });
        }
        break;
      case "ChangeEntity":
        if (orderDataZustand.orderUuid === "") {
          setMessageZustand(
            `Você precisa abrir uma conta antes de transferir.`,
            `error`
          );
        } else if (orderDataZustand.orderStatus === 2) {
          setMessageZustand(
            `Você precisa desbloquear a conta antes de transferir.`,
            `error`
          );
        } else if (
          orderDataZustand.products?.filter(
            (product: any) => product.productSelected
          ).length === 0 &&
          orderDataZustand.products?.filter(
            (product: any) => product.productSemiSelected
          ).length === 0
        ) {
          setMessageZustand(
            `Você precisa selecionar um produto para transferir.`,
            `error`
          );
        } else {
          if (selectedSaleOption.itemInfoValue.saleOptionType === "1") {
            setCurrentModalOpen("TransferOrderDeskModal");
          } else {
            setCurrentModalOpen("TransferOrderCounterModal");
          }
          setComponent();
        }
        break;
      case "PrintProduct":
        if (orderDataZustand.orderUuid === "") {
          setMessageZustand(
            `Você precisa abrir uma conta antes de imprimir a via de produção.`,
            `error`
          );
          return;
        }
        setCurrentModalOpen("ConfirmationModal");
        setConfirmModalOpen({
          title: `Produzir Pedido?`,
          description: `Deseja informar para a cozinha os itens do pedido?`,
          confirmationAction: async () => {
            setCurrentModalOpen("");
            setConfirmModalOpen({
              title: "",
              description: "",
              confirmationAction: () => { },
              cancelationAction: () => { },
            });
            api.post(
              `printProduction/${orderDataZustand.orderUuid}/${subsidiaryDataZustand.selectedPdv.selectedPeriod.periodType}`
            );
            setOrderDataZustand({
              ...orderDataZustand,
              orderStatus: 2,
            });
            setMessageZustand(
              `Pedido enviado para produção com sucesso!`,
              `success`
            );
            getPeriodInfo();
          },
          cancelationAction: () => { },
        });
        break;
      case "ChangeOrderStatus":
        if (orderDataZustand.orderUuid === "") {
          setMessageZustand(
            `Você precisa abrir uma conta antes de mudar de status.`,
            `error`
          );
          return;
        }
        setCurrentModalOpen("ConfirmationModal");
        setConfirmModalOpen({
          title:
            orderDataZustand.orderStatus === 5
              ? `Desbloquear Conta`
              : `Bloquear Conta`,
          description:
            orderDataZustand.orderStatus === 5
              ? `Desbloqueie a conta para que o cliente possa fazer novos pedidos.`
              : `Bloqueie a conta para que o cliente não possa fazer novos pedidos.`,
          confirmationAction: async () => {
            if (orderDataZustand.orderStatus === 5) {
              try {
                api.patch(`/order/${orderDataZustand.orderUuid}`, {
                  orderStatus: 1,
                });

                await setOrderDataZustand({
                  ...orderDataZustand,
                  orderStatus: 1,
                });

                setMessageZustand(`Conta desbloqueada com sucesso!`, `success`);
                setCurrentModalOpen("");
                setConfirmModalOpen({
                  title: "",
                  description: "",
                  confirmationAction: () => { },
                  cancelationAction: () => { },
                });
              } catch (error: any) {
                if (error.message === "Network Error") {
                  setMessageZustand(
                    `Erro ao tentar alterar status da conta, entre em contato com os administradores do Alfredo da sua unidade.`,
                    `error`
                  );
                } else {
                  setMessageZustand(
                    `Erro ao alterar status da conta: ${error.message}`,
                    `error`
                  );
                }
              }
            } else {
              try {
                api.patch(`/order/${orderDataZustand.orderUuid}`, {
                  orderStatus: 5,
                });

                await setOrderDataZustand({
                  ...orderDataZustand,
                  orderStatus: 5,
                });

                setMessageZustand(`Conta bloqueada com sucesso!`, `success`);
                setCurrentModalOpen("");
                setConfirmModalOpen({
                  title: "",
                  description: "",
                  confirmationAction: () => { },
                  cancelationAction: () => { },
                });
              } catch (error: any) {
                if (error.message === "Network Error") {
                  setMessageZustand(
                    `Erro ao tentar alterar status da conta, entre em contato com os administradores do Alfredo da sua unidade.`,
                    `error`
                  );
                } else {
                  setMessageZustand(
                    `Erro ao alterar status da conta: ${error.message}`,
                    `error`
                  );
                }
              }
            }
          },
          cancelationAction: () => { },
        });
        break;
      case "PrintOrderInfo":
        if (orderDataZustand.orderUuid === "") {
          setMessageZustand(
            `Você precisa abrir uma conta antes de imprimir a via de conferência.`,
            `error`
          );
          return;
        }
        api.post(
          `printOrder/${orderDataZustand.orderUuid}/${selectedSaleOption.itemInfoValue.saleOptionPrinterAddress}`
        );
        break;
      case "AddDiscount":
        if (orderDataZustand.orderUuid === "") {
          setMessageZustand(
            `Você precisa abrir uma conta antes de adicionar um desconto.`,
            `error`
          );
          return;
        }
        else if (orderDataZustand.orderStatus === 5) {
          setMessageZustand(
            `Você precisa desbloquear a conta antes de adicionar um desconto.`,
            `error`
          );
          return;
        }
        setCurrentModalOpen("AddDiscountModal");
        setComponent();
        break;
      case "ReviewOrderTax":
        if (orderDataZustand.orderUuid === "") {
          setMessageZustand(
            `Você precisa abrir uma conta antes de adicionar uma taxa.`,
            `error`
          );
          return;
        }
        else if (orderDataZustand.orderStatus === 5) {
          setMessageZustand(
            `Você precisa desbloquear a conta antes de adicionar uma taxa.`,
            `error`
          );
          return;
        }
        setCurrentModalOpen("ReviewOrderTaxModal");
        setComponent();
        break;
      case "ReviewOrderInfo":
        if (orderDataZustand.orderUuid === "") {
          setMessageZustand(
            `Você precisa abrir uma conta antes de revisar as informações dela.`,
            `error`
          );
          return;
        }
        setCurrentModalOpen("ReviewOrderInfoModal");
        setComponent();
        break;
      case "AddPayment":
        if (orderDataZustand.orderUuid === "") {
          setMessageZustand(`Você precisa abrir uma conta antes.`, `error`);
          return;
        }
        if (selectedSaleOption.itemInfoValue.saleOptionType === "3") {
          switch (orderDataZustand.orderStatus) {
            case 0:
              if (selectedSaleOption.itemInfoValue.saleOptionType === "3") {
                setCurrentModalOpen("AddPaymentModal");
              }
              else {
                setCurrentModalOpen("ConfirmationModal");
                setConfirmModalOpen({
                  title: `Confirmar Pedido?`,
                  description: `Deseja informar para o cliente a confirmação do pedido?`,
                  confirmationAction: () => {
                    setCurrentModalOpen("");
                    setConfirmModalOpen({
                      title: "",
                      description: "",
                      confirmationAction: () => { },
                      cancelationAction: () => { },
                    });
                    setOrderDataZustand({
                      ...orderDataZustand,
                      orderStatus: 1,
                    });
                    setMessageZustand(
                      `Pedido confirmado com sucesso!`,
                      `success`
                    );
                  },
                  cancelationAction: () => { },
                });
              }
              break;
            case 1:
              setCurrentModalOpen("AddPaymentModal");
              break;
            case 2:
              if (selectedSaleOption.itemInfoValue.saleOptionType === "3") {
                setCurrentModalOpen("ConfirmationModal");
                setConfirmModalOpen({
                  title: `Confirmar Envio do Pedido?`,
                  description: `Confirme se todos os itens do pedido estão sendo enviados.`,
                  confirmationAction: () => {
                    setCurrentModalOpen("sendToDeliveryModal");
                    setConfirmModalOpen({
                      title: "",
                      description: "",
                      confirmationAction: () => { },
                      cancelationAction: () => { },
                    });
                    getPeriodInfo();
                  },
                  cancelationAction: () => { },
                });
              }
              else {
                setCurrentModalOpen("ConfirmationModal");
                setConfirmModalOpen({
                  title: `Confirmar Produção dos Produtos?`,
                  description: `Deseja informar para que os produtos estão prontos?`,
                  confirmationAction: () => {
                    setCurrentModalOpen("");
                    setConfirmModalOpen({
                      title: "",
                      description: "",
                      confirmationAction: () => { },
                      cancelationAction: () => { },
                    });
                    setOrderDataZustand({
                      ...orderDataZustand,
                      orderStatus: 3,
                    });
                    setMessageZustand(
                      `Pedido confirmado com sucesso!`,
                      `success`
                    );
                  },
                  cancelationAction: () => { },
                });
              }
              break;
            case 3:
              setCurrentModalOpen("ConfirmationModal");
              setConfirmModalOpen({
                title: `Confirmar Envio do Pedido?`,
                description: `Confirme se todos os itens do pedido estão sendo enviados.`,
                confirmationAction: () => {
                  setCurrentModalOpen("sendToDeliveryModal");
                  setConfirmModalOpen({
                    title: "",
                    description: "",
                    confirmationAction: () => { },
                    cancelationAction: () => { },
                  });
                },
                cancelationAction: () => { },
              });
              break;
            case 4:
              const orderPrinted: boolean =
                orderDataZustand?.orderInfo?.some(
                  (info: any) => info.orderInfoType === 14
                );
              if (!orderPrinted) {
                setCurrentModalOpen("ConfirmationModal");
                setConfirmModalOpen({
                  title: `Conta não impressa`,
                  description: `Via de conferência da conta ainda não foi impressa, deseja continuar?`,
                  confirmationAction: () => {
                    setCurrentModalOpen("AddPaymentModal");
                    setConfirmModalOpen({
                      title: "",
                      description: "",
                      confirmationAction: () => { },
                      cancelationAction: () => { },
                    });
                    setComponent();
                  },
                  cancelationAction: () => { },
                });
              } else {
                setCurrentModalOpen("AddPaymentModal");
              }
              break;
            default:
              break;
          }
        } else {
          const orderPrinted: boolean =
            orderDataZustand?.orderInfo?.orderPrinted;
          if (!orderPrinted) {
            setCurrentModalOpen("ConfirmationModal");
            setConfirmModalOpen({
              title: `Conta não impressa`,
              description: `Via de conferência da conta ainda não foi impressa, deseja continuar?`,
              confirmationAction: () => {
                setCurrentModalOpen("AddPaymentModal");
                setConfirmModalOpen({
                  title: "",
                  description: "",
                  confirmationAction: () => { },
                  cancelationAction: () => { },
                });
              },
              cancelationAction: () => { },
            });
          } else {
            setCurrentModalOpen("AddPaymentModal");
          }
        }

        break;
      case "PartialWithdrawal":
        setCurrentModalOpen("PartialWithdrawalModal");
        setComponent();
        break;
      case "PeriodContent":
        setCurrentModalOpen("PeriodContentModal");
        setComponent();
        break;
      case "AccessOrders":
        setCurrentModalOpen("PeriodOrdersModal");
        setComponent();
        break;
      case "BackToHome":
        setOrderDataZustand({
          orderUuid: "",
          orderCode: "",
          orderOwnerUuid: "",
          orderOwnerName: "",
          orderStatus: 0,
          orderType: "",
          createdAt: "",
          orderInfo: {
            peopleNumber: "",
            deskName: "",
            deskUuid: "",
          },
        });
        window.location.href = "/";
        break;
    }
  };

  const labels: any = {
    AddProduct: "Adicionar Produto",
    AddObservation: "Adicionar Observação",
    CancelOrder: "Cancelar (pedido/produto/observação)",
    ChangeEntity: "Transferir",
    PrintProduct: "Imprimir Produção",
    ChangeOrderStatus: "Mudar Status",
    PrintOrderInfo: "Imprimir Conferência",
    AddDiscount: "Adicionar Desconto",
    ReviewOrderTax: "Revisar Taxas da Conta",
    AddPayment: "Adicionar Pagamento",
    AccessOrders: "Acessar Contas",
    BackToHome: "Voltar para o Início",
    PartialWithdrawal: "Retirada Parcial",
    PeriodContent: "Iniciar/Encerrar Período",
    OpenOrder: "Abrir Conta",
    ReviewOrderInfo: "Atualizar Informações da Conta",
  };
  return allOptionsOpen ? (
    <Styles.Modal
      ref={ref}
      background={selectedSaleOption.itemInfoValue.saleOptionBackgroundColor}
      cursorTop={modalPosition.top}
      cursorLeft={modalPosition.left}
    >
      <Styles.Dropdown>
        <Styles.DropdownItem onClick={() => handleButtonClick("BackToHome")}>
          <Styles.DropdownItemTitle>Inicio</Styles.DropdownItemTitle>
          <Styles.Shortcut>Atalho: CTRL + H</Styles.Shortcut>
        </Styles.DropdownItem>
        {subsidiaryDataZustand.selectedPdv.saleOptions.map(
          (currentSaleOption: any, index) =>
            currentSaleOption.itemInfoUuid !== saleOption && (
              <Styles.DropdownItem
                key={index}
                onClick={async () => {
                  setCurrentModalOpen("");
                  await navigate(
                    `/point-of-sale/${currentSaleOption.itemInfoUuid}`
                  );
                  window.location.reload();
                }}
              >
                <Styles.DropdownItemTitle>
                  {currentSaleOption.itemInfoValue.saleOptionName}
                </Styles.DropdownItemTitle>
                <Styles.Shortcut>Atalho: CTRL + {index + 1}</Styles.Shortcut>
              </Styles.DropdownItem>
            )
        )}
        {selectedSaleOption?.itemInfoValue.saleOptionComponents?.map(
          (component: any, index) =>
            component.componentType.includes("Button") &&
            component.componentProps.componentAction !== "BackToHome" &&
            component.componentProps.componentAction !== "AllOptions" && (
              <Styles.DropdownItem
                key={index}
                onClick={() =>
                  handleButtonClick(component.componentProps.componentAction)
                }
              >
                <Styles.DropdownItemTitle>
                  {labels[component.componentProps.componentAction]}
                </Styles.DropdownItemTitle>
                {component.componentProps.componentShortcut && (
                  <Styles.Shortcut>
                    Atalho: {component.componentProps.componentShortcut}
                  </Styles.Shortcut>
                )}
              </Styles.DropdownItem>
            )
        )}
        <Styles.DropdownItem onClick={() => handleButtonClick("PeriodContent")}>
          <Styles.DropdownItemTitle>Fechar Período</Styles.DropdownItemTitle>
        </Styles.DropdownItem>
        <Styles.DropdownItem onClick={() => handleClose()}>
          <Styles.DropdownItemTitle>Fechar</Styles.DropdownItemTitle>
          <Styles.Shortcut>Atalho: Esc</Styles.Shortcut>
        </Styles.DropdownItem>
      </Styles.Dropdown>
    </Styles.Modal>
  ) : null;
};
export default AllOptionsModal;
